import React, { PropTypes } from "react";
import ReferralDashboardTable from "./ReferralDashboardTable";
import axios from "axios";
import LoadingSpinner from "../../feature/loadingSpinner";

class ReferralDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      referrals: [],
      loading: true,
    };
    this.getAllReferrals = this.getAllReferrals.bind(this);
  }

  getAllReferrals(){
    axios
      .get(
        process.env.REQ_URL +
          "/referral/getAllReferrals",
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      )
      .then(response => {
        this.setState({ referrals: response.data.data, loading: false });
      })
      .catch(error => {
        console.log(
          "error while calling api /referral/getAllReferrals" + error
        );
      });
  }

  componentDidMount() {
    this.getAllReferrals();
  }

  refresh() {
    this.getAllReferrals();
  }

  render() {
    return (
      <div>
        <div className="tabContent">
          {this.state.loading ? <LoadingSpinner /> : <ReferralDashboardTable referrals={this.state.referrals}/>}
        </div>
      </div>
    );
  }
}

ReferralDashboard.proptypes = {};

export default ReferralDashboard;



/** WEBPACK FOOTER **
 ** ./src/components/Referral/ReferralDashboard.js
 **/